var render = function render() {
  var _vm$dataList$, _vm$dataList$2;
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    ref: "microContainer",
    staticClass: "new-media-detail",
    class: {
      'is-warning': _vm.firstIsForewarning,
      // 'animation-border': dragActive,
      'transparent-bg': _vm.isAnmiationBack
    },
    style: _vm.microContainerStyle
  }, [_vm.isFeedAnimation ? _c('animationDrag', {
    on: {
      "touchDragEnd": _vm.goBackAnimationLayout,
      "dragActive": _vm.handleDragActive
    }
  }) : _vm._e(), _c('animationImgCover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAnmiationBack,
      expression: "isAnmiationBack"
    }],
    attrs: {
      "src-cover": _vm.firstLowImg,
      "img-height": _vm.animationImgHeight
    }
  }), _c('div', {
    class: {
      'animation-opacity': _vm.isAnmiationBack
    }
  }, [!_vm.isHiddeNav && (_vm.isBaiduMap || _vm.isBaiduMapAuto) ? _c('om-title-bar', {
    staticClass: "micro-page-title",
    class: {
      'page-title-border': _vm.visiblePageBorderRadius,
      'micro-trans-bg': _vm.transBgColor
    },
    attrs: {
      "id": "page-title-bar",
      "content": _vm.transBgColor ? '' : _vm.pageTitle,
      "new-back-btn": _vm.hiddenBackBtn,
      "title-left-style": _vm.titleLeftStyle,
      "title-content-style": _vm.titleContentStyle
    },
    on: {
      "click-left": _vm.navigatorBack,
      "title-created": _vm.handleTitleCreated
    },
    nativeOn: {
      "dblclick": function ($event) {
        $event.stopPropagation();
        return _vm.handleTitleContent.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([_vm.transBgColor ? {
      key: "content",
      fn: function () {
        return [_c('div', {
          staticClass: "title-iswarning"
        })];
      },
      proxy: true
    } : null, _vm.searchBtnIcon ? {
      key: "right-content",
      fn: function () {
        return [_c('div', {
          staticClass: "title-iconRight",
          on: {
            "click": _vm.homePageClick
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }) : _vm._e(), _vm.dataList && _vm.dataList.length ? _c('operateActivity', {
    model: {
      value: _vm.isFeedScrolled,
      callback: function ($$v) {
        _vm.isFeedScrolled = $$v;
      },
      expression: "isFeedScrolled"
    }
  }) : _vm._e(), _vm.showTopTitle ? _c('topPoiTitle', {
    ref: "topPoiTitle",
    attrs: {
      "top-poi-info": _vm.topPoiInfo,
      "stbar-height": _vm.stbarHeight
    }
  }) : _vm._e(), _vm.topPoiInfo && _vm.topPoiInfo.desc ? _c('div', [_vm.topPoiInfo && _vm.topPoiInfo.desc ? _c('div', [_c('div', {
    staticClass: "top-desc"
  }, [_vm._v(" " + _vm._s(_vm.topPoiInfo.desc))])]) : _vm._e()]) : _vm._e(), _vm.phoneInfo.sv ? _c('ctripCardList', {
    attrs: {
      "phone-info": _vm.phoneInfo,
      "source": _vm.source
    },
    on: {
      "emitCtripCardData": _vm.handleCardData
    }
  }) : _vm._e(), _vm.topPoiInfo && _vm.topPoiInfo.desc || _vm.hasCtripCard ? _c('div', {
    staticClass: "item-bottom-line",
    class: {
      'line-height': _vm.hasCtripCard
    }
  }) : _vm._e(), _c('div', {
    ref: "vanListWrap",
    staticClass: "van-list-wrap",
    style: _vm.containerStyle,
    attrs: {
      "id": "feed-list-wrap"
    }
  }, [_c('div', {
    ref: "contentStart",
    staticStyle: {
      "height": "0"
    }
  }), _c('div', {
    style: _vm.errorBarStyle
  }), _c('banner'), _c('om-list', {
    ref: "vanList",
    attrs: {
      "error": _vm.error,
      "error-text": "请求失败，点击重新加载",
      "finished": _vm.finishedFlag,
      "immediate-check": false,
      "offset": 1000
    },
    on: {
      "update:error": _vm.handleErrorUpdate,
      "load": _vm.loadData
    },
    scopedSlots: _vm._u([{
      key: "loading",
      fn: function () {
        return [_c('div', {
          staticClass: "custom-loading"
        }, [_c('img', {
          attrs: {
            "src": _vm.loadingIcon
          }
        })])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.bottomLoadingFlag,
      callback: function ($$v) {
        _vm.bottomLoadingFlag = $$v;
      },
      expression: "bottomLoadingFlag"
    }
  }, [_vm.microPoiDetail.poi_info && !_vm.isBaiduMap && _vm.dataType !== 'poicomment' ? [_c('poiDetail', {
    attrs: {
      "detail": _vm.microPoiDetail,
      "is-map-feed-finished": _vm.isMapFeedFinished
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap,
      "getFeedData": _vm.getArticleData
    }
  }), _c('div', {
    staticClass: "item-bottom-line sm"
  })] : _vm._e(), _vm._l(_vm.dataList, function (item, i) {
    return _c('div', {
      key: i,
      staticClass: "micro-container",
      staticStyle: {
        "position": "relative"
      }
    }, [i === 0 && item.aiPush === 'ai_tourist_guide' && item.body ? _c('aiNote', {
      ref: "aiNoteRef",
      refInFor: true,
      attrs: {
        "ai-note-obj": item.body
      },
      on: {
        "jump-url": _vm.jumpUrl
      }
    }) : _vm._e(), i === 0 && _vm.usePushNote(item.tpSource, _vm.source) && item.aiPush !== 'ai_tourist_guide' ? _c('push-note', {
      attrs: {
        "push-data": item,
        "push-index": i
      },
      on: {
        "content-open": function ($event) {
          return _vm.contentOpen(item);
        },
        "open-Baidu-Map": _vm.jumpToMap
      }
    }) : _vm._e(), i === 1 && _vm.urlParams.ad === '1' ? _c('ad-space-sdk', {
      attrs: {
        "ad-type": _vm.adType,
        "ad-info": _vm.adInfo,
        "ad-aspect-ratio": _vm.adAspectRatio,
        "ad-core-utils": _vm.adCoreUtils
      }
    }) : _vm._e(), _c('microNote', {
      attrs: {
        "micro-index": i,
        "micro-poi-detail": _vm.microPoiDetail,
        "jump-wx-app-url": _vm.jumpWxAppUrl
      },
      on: {
        "open-share": _vm.updateWxShare,
        "jumpToMap": _vm.jumpToMap
      }
    }), _c('div', {
      staticClass: "item-bottom-line",
      class: {
        'line-height': _vm.isScreenOptimization
      }
    }), _vm.commentFinishedFlag && i === _vm.commenIndex ? _c('content-end-bar') : _vm._e(), _c('middle-dom', {
      attrs: {
        "index": i
      }
    })], 1);
  })], 2), _vm.showLoadingDv ? _c('loading') : _vm._e(), _vm.finishedFlag ? _c('div', [_c('div', {
    staticClass: "custom-finished"
  }, [_c('img', {
    attrs: {
      "src": _vm.finishedIcon
    }
  })])]) : _vm._e(), _vm.finishedFlag ? _c('end-dom', {
    attrs: {
      "num": _vm.dataList.length,
      "level-one": _vm.levelOne,
      "level-two": _vm.levelTwo
    }
  }) : _vm._e()], 1), !_vm.isBaiduMap && !_vm.isBaiduMapAuto ? [_vm.downloadShowFlag ? _c('DownLoadDialog', {
    on: {
      "handleClick": _vm.handleClick
    }
  }) : _vm._e(), _c('bottomBtn', {
    attrs: {
      "jump-wx-app-url": _vm.jumpWxAppUrl
    },
    on: {
      "open-Baidu-Map": _vm.jumpToMap
    }
  })] : _vm._e(), _vm.showTempIframe ? _c('div', {
    ref: "tempIframeDv",
    staticStyle: {
      "height": "0"
    }
  }, [_c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticStyle: {
      "height": "0"
    },
    attrs: {
      "id": "tempIframe",
      "scrolling": "no",
      "frameborder": "0"
    }
  })]) : _vm._e(), _vm.dataList && _vm.dataList.length ? _c('timeTask', {
    attrs: {
      "tp-source": ((_vm$dataList$ = _vm.dataList[0]) === null || _vm$dataList$ === void 0 ? void 0 : _vm$dataList$.tpSource) || '',
      "std-tag": ((_vm$dataList$2 = _vm.dataList[0]) === null || _vm$dataList$2 === void 0 || (_vm$dataList$2 = _vm$dataList$2.guide) === null || _vm$dataList$2 === void 0 || (_vm$dataList$2 = _vm$dataList$2.bury) === null || _vm$dataList$2 === void 0 ? void 0 : _vm$dataList$2.stdTag) || '',
      "is-dark": _vm.is_dark
    },
    on: {
      "clickTask": _vm.goBdLogin
    },
    model: {
      value: _vm.isFeedScrolled,
      callback: function ($$v) {
        _vm.isFeedScrolled = $$v;
      },
      expression: "isFeedScrolled"
    }
  }) : _vm._e(), _vm.showConfirmModal ? _c('confirm-modal', {
    attrs: {
      "cancel-text": _vm.guideCancelText,
      "confirm-text": _vm.guideConfirmText,
      "title": _vm.guideTitle,
      "message": _vm.guideMessage
    },
    on: {
      "onCancel": _vm.handleModalCancel,
      "onConfirm": _vm.handleModalConfirm
    }
  }) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };